export const packageList = [
  {
    name: 'sys',
    activeRule: ['ams', 'mcs', 'inform-center'],
  },
  {
    name: 'bss_uamp',
    activeRule: ['uamp']
  },
  {
    name: 'bss_flow',
    activeRule: []
  },
  {
    name: 'bss_common',
    activeRule: []
  },
  {
    name: 'bss',
    activeRule: ['bss'], // 组件平台
  },
  {
    name: 'devops_flow',
    activeRule: []
  },
  {
    name: 'bss_opa',
    activeRule: ['opa']
  },
  {
    name: 'bss_config',
    activeRule: ['bss-config']
  }
]
export const remoteModuleConfig = {
  dev: ['sys', 'bss_uamp', 'bss_flow', 'bss_common', 'bss', 'devops_flow', 'bss_opa', 'bss_config'],
  stg: ['sys', 'bss_uamp', 'bss_flow', 'bss_common', 'bss', 'devops_flow', 'bss_opa', 'bss_config'],
  uat: ['sys', 'bss_uamp', 'bss_flow', 'bss_common', 'bss', 'devops_flow', 'bss_opa', 'bss_config'],
  prd: ['sys', 'bss_uamp', 'bss_flow', 'bss_common', 'bss', 'devops_flow', 'bss_opa', 'bss_config'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/bss/index.js